import type { ColorsType } from "Components/Layout/Themes/Themes";

export const Colors: ColorsType = {
  PrimaryMain: "#006AFF",
  PrimaryDark: "#085FD9",
  PrimaryDeep: "#0052CC",
  PrimaryText: "#ffffff",
  SecondaryMain: "#65EE9C",
  SecondaryDark: "#65EE9C",
  SecondaryText: "#353539",
  Body: "#ffffff",
  Red: "#DD0606",
  RedDark: "#DA4242",
  DeleteRed: "#E02020",
  Warning: "#F7B500",
  WarningDark: "#c08c00",
  Green: "#00C44E", //"#70f0a6",
  GreenDark: "#008939",
  SuccessDark: "#00A843",
  Text: "#353539",
  TextLight: "#69696E",
  PlaceholderGray: "#bcbcbc",
  Black: "#353539",
  White: "#ffffff",
  Gray: "#F9F9FA",
  LightGray: "#F5F5F6",
  MediumGrey: "#eaeaf0",
  DarkGrey: "#555555",
  Border: "#DDDDDD",
  BackgroundGrey: "#FAFAFA", //"#F5F5F5",
  Link: "#006AFF",
  LevelProgressBar: "#b1b1b9",
  DarkOrange: "#E66000",
  DarkOrangeHover: "#C25500",
  Purple: "#7300FF",
  SpaceBlack: "#080c14",
  Gold: "#FFD700",
  InfoBox: {
    Error: {
      Background: "#FFEBEE",
      Border: "#D32F2F",
    },
    Warning: {
      Background: "#FDECDB",
      Border: "#C46C04",
    },
    Info: {
      Background: "#DEEAFE",
      Border: "#3640F5",
    },
    Success: {
      Background: "#E8F5E9",
      Border: "#00C44E",
    },
  },
};
